import StudentDictionary from "@/dictionary/StudentDictionary";
import BaseModel from "./BaseModel";
import DateHandler from "@/composables/handlers/DateHandler";

/**
 * Student
 */
export default class Student extends BaseModel{
  constructor({
    id,
    name,
    birth_date,
    nacionality,
    occupation,
    document,
    document_type,
    address,
    class_frequency,
    duration_in_minutes,
    class_time,
    payment_day,
    photo,
    status,
    user,
    user_email,
    allowed,
    created_at,
    updated_at
  }) {
    super();

    this.id = id || null;
    this.name = name || null;
    this.birth_date = birth_date || null;
    this.nacionality = nacionality || null;
    this.occupation = occupation || null;
    this.document = document || null;
    this.document_type = document_type || null;
    this.address = address || null;
    this.class_frequency = class_frequency || null;
    this.duration_in_minutes = duration_in_minutes || null;
    this.class_time = class_time || null;
    this.payment_day = payment_day || null;
    this.photo = photo || null;
    this.status = status || null;
    this.user = user || null;
    this.user_email = user_email || null;
    this.allowed = allowed || null;
    this.created_at = created_at || null;
    this.updated_at = updated_at || null;

    this.statusDictionary = new StudentDictionary();
  }

  /**
   * Gets Student photo
   * @returns {String}
   */
  getPhoto() {
    if (this.photo && this.photo.includes('data:image/jpeg;base64,')) {
      return this.photo;
    }
    return this.photo ? `data:image/jpeg;base64,${this.photo}` : '';
  }

  /**
   * Gets Birth_date
   * @returns {string|Null}
   */
  getBirthDate() {
    if (this.birth_date != null) {
      return DateHandler.format(this.birth_date, 'DATE_SHORT');
    }

    return null;
  }

  /**
   * Gets ClassSchedule
   * @returns {Array}
   */
  getClassSchedule() {
    if (!this.class_time) {
      return [];
    }

    return JSON.parse(this.class_time || []);
  }

  /**
   * Gets if Student is ACTIVE
   * @returns {Boolean}
   */
  isActive() {
    return this.statusDictionary.ACTIVE == this.status;
  }

  /**
   * Gets if Student is ALLOWED
   * @returns {Boolean}
   */
  isAllowed() {
    return this.allowed ? true : false;
  }
}
